export const getSquadCasesInOtherAreasWithCreatedBy = (formattedUserIdList, limit) => `
SELECT
    Id,
    CaseNumber,
    CreatedDate,
    Imagem_Status__c,
    Status,
    Subject,
    Owner.Name,
    OwnerId
FROM
    Case
WHERE
    CreatedBy.Id IN (${formattedUserIdList})
    AND OwnerId NOT IN (${formattedUserIdList}, '00G41000002Q39NEAS', '00G41000001ohGLEAY')
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
    ${limit ? `LIMIT ${limit}` : ''}
`;
